import React from 'react';
import { Button, Alert } from 'reactstrap';

const DatabaseSyncSection = ({ onSync, isSyncing, repairDbMessage, repairDbTypeMessage }) => {
    return (
        <div className="action-item mt-4 p-3 border rounded">
            <h6>Синхронизация базы данных</h6>
            <Button
                color="warning"
                onClick={onSync}
                className="dt1520-button mt-2"
                outline
                disabled={isSyncing}
            >
                {isSyncing ? 'Синхронизация...' : 'Синхронизировать базу данных'}
            </Button>
            {isSyncing && (
                <div className="mt-2">
                    <small className="text-muted">Выполняется синхронизация, пожалуйста, подождите...</small>
                </div>
            )}
            {repairDbMessage && (
                <Alert color={repairDbTypeMessage === 'success' ? 'success' : 'danger'} className="mt-3 ml-3">
                    {repairDbMessage}
                </Alert>
            )}
        </div>

    );
};

export default DatabaseSyncSection;